import type { v2, ControlTypeFunction } from '@sap/ux-specification-types';
import { ControlType, DefinitionName } from '@sap/ux-specification-types';
import { syncRule } from '../../../common/decoration/decorators';
import { addPatternForBindingChangeOfEnumOP, buildControlIdFromParent, convertSectionId } from '../../../common';

export const getTableSectionControlId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType: ControlTypeFunction,
    facetId: string
): string => {
    const convertedId = convertSectionId(breadcrumbs[1], facetId);
    const breadcrumbsTrail = [convertedId, DefinitionName.Table];
    return buildControlIdFromParent(baseId, breadcrumbsTrail);
};
export const getFormSectionControlId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType: ControlTypeFunction,
    facetId: string
): string => {
    const convertedId = convertSectionId(breadcrumbs[1], facetId);
    const breadcrumbsTrail = [convertedId, 'FormGroup'];
    return buildControlIdFromParent(baseId, breadcrumbsTrail);
};

export const getChartSectionControlId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType: ControlTypeFunction,
    facetID: string
): string => {
    const convertedId = convertSectionId(breadcrumbs[1], facetID);
    const breadcrumbsTrail = [convertedId, 'Chart'];
    return buildControlIdFromParent(baseId, breadcrumbsTrail);
};

export const getSectionControlId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType: ControlTypeFunction,
    facetId: string
): string => {
    const convertedId = convertSectionId(breadcrumbs[1], facetId);
    const breadcrumbsTrail = [convertedId, 'Section'];
    return buildControlIdFromParent(baseId, breadcrumbsTrail);
};

export const getSubSectionControlId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType: ControlTypeFunction,
    facetId: string
): string => {
    const convertedId = convertSectionId(breadcrumbs[1], facetId);
    const breadcrumbsTrail = [convertedId, 'SubSection'];
    return buildControlIdFromParent(baseId, breadcrumbsTrail);
};

export const getContactSubSectionControlId = (
    baseId: string,
    _idBreadcrumbs: string[],
    breadcrumbs: string[],
    _controlType: ControlTypeFunction,
    facetId: string
): string => {
    const convertedId = convertSectionId(breadcrumbs[1], facetId);
    const breadcrumbsTrail = [convertedId, 'ContactsList'];
    return buildControlIdFromParent(baseId, breadcrumbsTrail);
};

export class ObjectPageSectionV2 implements v2.ObjectPageSectionV2 {
    @syncRule({
        flex: {
            controlId: getSectionControlId,
            controlType: (): ControlType => ControlType.Section
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSectionFormV2 implements v2.ObjectPageSectionFormV2 {
    @syncRule({
        flex: {
            controlId: getSectionControlId,
            controlType: (): ControlType => ControlType.Section
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSectionChartV2 implements v2.ObjectPageSectionChartV2 {
    @syncRule({
        flex: {
            controlId: getSectionControlId,
            controlType: (): ControlType => ControlType.Section
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSectionTableV2 implements v2.ObjectPageSectionTableV2 {
    @syncRule({
        flex: {
            controlId: getSectionControlId,
            controlType: (): ControlType => ControlType.Section
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSectionAddressV2 implements v2.ObjectPageSectionAddressV2 {
    @syncRule({
        flex: {
            controlId: getSectionControlId,
            controlType: (): ControlType => ControlType.Section
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSectionContactV2 implements v2.ObjectPageSectionContactV2 {
    @syncRule({
        flex: {
            controlId: getSectionControlId,
            controlType: (): ControlType => ControlType.Section
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSubSectionV2 implements v2.ObjectPageSubSectionV2 {
    @syncRule({
        flex: {
            controlId: getSubSectionControlId,
            controlType: (): ControlType => ControlType.SubSection
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSubSectionFormV2 implements v2.ObjectPageSubSectionV2 {
    @syncRule({
        flex: {
            controlId: getFormSectionControlId,
            controlType: (): ControlType => ControlType.Group
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSubSectionChartV2 implements v2.ObjectPageSubSectionV2 {
    @syncRule({
        flex: {
            controlId: getChartSectionControlId,
            controlType: (): ControlType => ControlType.SmartChart
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSubSectionContactV2 implements v2.ObjectPageSubSectionContactV2 {
    @syncRule({
        flex: {
            controlId: getContactSubSectionControlId,
            controlType: (): ControlType => ControlType.SubSection
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}

export class ObjectPageSubSectionTableV2 implements v2.ObjectPageSubSectionV2 {
    @syncRule({
        flex: {
            controlId: getTableSectionControlId,
            controlType: (): ControlType => ControlType.SmartTable
        },
        generate: addPatternForBindingChangeOfEnumOP
    })
    visible?: boolean;
}
